import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { Screen } from "../components/Screen";
import { CountUp } from "../components/CountUp";
import { Ref } from "../components/Ref";
import { Reveal } from "../components/Reveal";
import { useSnak } from "../snak/SnakContext";
import { studyDesignDetail } from "../content/details";
export function P1Evidence() {
  const {
    openDetail
  } = useSnak();
  const openDesign = () => openDetail(studyDesignDetail);
  return <Screen overline={<>
          MINT · final results, October 2026<Ref n={1} data-id="element-406" data-mp="yksbm7ghzoaf" />
        </>} refTarget={1} detail={{
    label: "Study design",
    onClick: openDesign
  }} footnote={<p data-id="element-407" data-mp="18c64vxhuvrv4">
          MINT is an observational, non-randomised, multicentre real-world study; results do not establish causality or
          comparative effectiveness. Figures are provisional and subject to verification against the full final study
          materials. Best overall response: complete or partial response as best response during treatment (definition to
          be confirmed).<Ref n={1} data-id="element-408" data-mp="1ezjt3hfkh8jq" />
        </p>} data-id="element-405" data-mp="ymuzaku6h5bz">
      <Reveal delay={0.1} data-id="element-409" data-mp="1f0leofu7ldfp">
        <h1 className="mt-5 font-display text-[34px] font-medium leading-[1.08] tracking-[-0.01em]" data-id="element-410" data-mp="1f1wj8hvhap7v">
          New German real-world evidence in <em className="font-medium text-[var(--s-accent)]" data-id="element-411" data-mp="1o103hp6dtany">MF and SS.</em>
        </h1>
      </Reveal>

      <Reveal delay={0.25} data-id="element-412" data-mp="1t0mf5u6kaiun">
        <div className="mt-8 flex items-start" data-id="element-413" data-mp="1szbbrvh13d42">
          <span className="font-display text-[124px] font-medium leading-[0.82] tracking-[-0.03em]" data-id="element-414" data-mp="1xynxgcw5ye52">
            <CountUp to={62.4} duration={2} delay={0.4} data-id="element-415" data-mp="22p4e05va6fvn" />
          </span>
          <span className="ml-1 font-display text-[46px] font-medium leading-none" data-id="element-416" data-mp="22s0ea0ulpgn9">%</span>
        </div>
        <p className="overline mt-5 leading-[1.6]" data-id="element-417" data-mp="2bqcbwmtvxep7">
          Best overall response rate<Ref n={1} data-id="element-418" data-mp="2bo9br9z0q56r" />
        </p>
        <div className="mt-4" aria-hidden data-id="element-419" data-mp="2gp5o8bxfqzns">
          <div className="relative h-[3px] bg-[var(--s-track)]" data-id="element-420" data-mp="2gpyocu1w2qwy">
            <motion.div className="absolute inset-y-0 left-0 bg-[var(--s-accent)]" initial={{
            width: "0%"
          }} animate={{
            width: "62.4%"
          }} transition={{
            duration: 2,
            delay: 0.4,
            ease: [0.16, 1, 0.3, 1]
          }} data-id="element-421" data-mp="gmnz0pqwnfqh" />
          </div>
          <div className="tabular mt-1.5 flex justify-between text-[10px] text-[var(--s-muted)]" data-id="element-422" data-mp="lmipwtaok5bj">
            <span data-id="element-423" data-mp="10aww9e7b2bwu">0%</span>
            <span data-id="element-424" data-mp="10a3xazel8qp9">100%</span>
          </div>
        </div>
      </Reveal>

      <Reveal delay={0.45} data-id="element-425" data-mp="vcc0ps300geq">
        <div className="mt-7 grid grid-cols-2 border-t border-[var(--s-rule)] pt-5" data-id="element-426" data-mp="vb0rvdup4igr">
          <div data-id="element-427" data-mp="19c3dxqloxsro">
            <p className="font-display text-[44px] font-medium leading-none" data-id="element-428" data-mp="19ajxo001bhpw">109</p>
            <p className="mt-2 text-[12.5px] text-[var(--s-muted)]" data-id="element-429" data-mp="14ciab2vksw8m">patients</p>
          </div>
          <div className="border-l border-[var(--s-rule)] pl-5" data-id="element-430" data-mp="3b2eu58dpzfnj">
            <p className="font-display text-[44px] font-medium leading-none" data-id="element-431" data-mp="3644x0s8fq4za">18</p>
            <p className="mt-2 text-[12.5px] text-[var(--s-muted)]" data-id="element-432" data-mp="3667yq9iy9mju">German centers</p>
          </div>
        </div>
        <button onClick={openDesign} className="group mt-7 flex items-center gap-2 text-[13px] font-semibold tracking-[0.14em] text-[var(--s-accent)]" data-id="element-433" data-mp="1ql5xqhils0je">
          EXPLORE STUDY DESIGN
          <ArrowRight className="h-4 w-4 transition-transform duration-150 group-hover:translate-x-0.5" strokeWidth={1.75} data-id="element-434" data-mp="1gv4b7u5weq6l" />
        </button>
      </Reveal>
    </Screen>;
}